import React from 'react';

const Reward = props => {
  const { width, colors } = props;
  const { primary } = colors;
  const h = 200;
  const w = 200;

  return (
    <svg
      data-name="Group 820"
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 200 200"
      {...props}>
      <defs>
        <clipPath id="prefix__a">
          <path data-name="Rectangle 1156" d="M0 0h200v200H0z" />
        </clipPath>
        <clipPath id="prefix__b">
          <path
            data-name="Rectangle 9"
            fill="#f5ba3d"
            stroke="#707070"
            strokeWidth={0.293}
            d="M0 0h100.03v99.392H0z"
          />
        </clipPath>
        <clipPath id="prefix__c">
          <path
            data-name="Rectangle 12"
            d="M4.648 3.173l19.992.037.036 19.89-19.992-.038z"
            fill="#fff"
            stroke="#707070"
            strokeWidth={0.293}
          />
        </clipPath>
        <clipPath id="prefix__d">
          <path
            data-name="Rectangle 12"
            d="M0 0l19.983-.049-.049 19.9-19.983.049z"
            fill="#fff"
            stroke="#707070"
            strokeWidth={0.293}
          />
        </clipPath>
        <clipPath id="prefix__e">
          <path
            data-name="Rectangle 12"
            d="M0 0l20-.017-.017 19.88-20 .017z"
            fill="#fff"
            stroke="#707070"
            strokeWidth={0.293}
          />
        </clipPath>
        <clipPath id="prefix__f">
          <path
            data-name="Rectangle 12"
            d="M7.124 5.971l19.987.057.057 19.935-19.987-.057z"
            fill="#fff"
            stroke="#707070"
            strokeWidth={0.294}
          />
        </clipPath>
        <clipPath id="prefix__g">
          <path
            data-name="Rectangle 15"
            d="M6.167 4.121l27.617.048.049 27.819-27.618-.049z"
            fill="#fff"
            stroke="#707070"
            strokeWidth={0.293}
          />
        </clipPath>
        <clipPath id="prefix__h">
          <path
            data-name="Rectangle 16"
            d="M0 0h27.747v25.2H0z"
            fill="#fff"
            stroke="#707070"
            strokeWidth={0.293}
          />
        </clipPath>
      </defs>
      <g clipPath="url(#prefix__a)">
        <g
          data-name="Mask Group 2"
          transform="translate(49.635 50.254)"
          clipPath="url(#prefix__b)">
          <g data-name="gift (2)">
            <path
              data-name="Path 8"
              d="M76.811 11.446C73.83 5.91 70.262 3.097 66.207 3.097c-4.673 0-9.527 3.795-14.432 11.283a67.699 67.699 0 00-1.757 2.841 65.476 65.476 0 00-1.758-2.841C43.358 6.892 38.503 3.097 33.83 3.097c-4.059 0-7.63 2.805-10.6 8.349a8.533 8.533 0 00-.357 8.884c1.92 3.181 6.212 5.326 13.122 6.56a83.657 83.657 0 0013.794 1.083h.48a83.659 83.659 0 0013.79-1.083c6.908-1.225 11.2-3.379 13.124-6.56a8.539 8.539 0 00-.372-8.884z"
              fill="#da4453"
            />
            <path
              data-name="Path 9"
              d="M93.777 43.116a4.156 4.156 0 00-4.169-4.141H10.421a4.154 4.154 0 00-4.169 4.141v49.028a4.154 4.154 0 004.169 4.141h79.187a4.156 4.156 0 004.169-4.141z"
              fill="#ffca3b"
            />
            <path
              data-name="Path 10"
              d="M100.03 46.592a4.156 4.156 0 01-4.169 4.142H4.169A4.154 4.154 0 010 46.592V25.885a4.158 4.158 0 014.169-4.142h91.69a4.158 4.158 0 014.169 4.143z"
              fill="#ffdb57"
            />
            <path
              data-name="Rectangle 10"
              fill="#ed5564"
              d="M39.596 21.741h20.842v28.987H39.596z"
            />
            <path
              data-name="Path 11"
              d="M6.252 54.826h87.525v-3.963H6.252z"
              opacity={0.134}
            />
            <path
              data-name="Rectangle 11"
              fill="#da4453"
              d="M39.596 50.729h20.842v45.555H39.596z"
            />
            <path
              data-name="Path 12"
              d="M39.593 54.826h20.842v-3.963H39.593z"
              opacity={0.134}
            />
          </g>
        </g>
        <g
          data-name="Mask Group 3"
          transform="rotate(-18.01 98.214 -157.144)"
          clipPath="url(#prefix__c)">
          <path
            d="M14.645 3.68l3.1 6.231 6.909 1.007-4.99 4.841 1.194 6.844-6.183-3.24-6.172 3.218L9.67 15.74l-5.008-4.854 6.9-.982z"
            fill="#ffeb00"
          />
        </g>
        <g
          data-name="Mask Group 4"
          transform="rotate(25.97 -126.068 428.833)"
          clipPath="url(#prefix__d)">
          <path
            data-name="star"
            d="M9.99.462l3.069 6.222 6.9.978-5.005 4.866 1.162 6.846-6.166-3.216-6.182 3.248 1.2-6.853-4.987-4.831 6.906-1.016z"
            fill="#ffeb00"
          />
        </g>
        <g
          data-name="Mask Group 5"
          transform="rotate(8 -162.6 1095.933)"
          clipPath="url(#prefix__e)">
          <path
            data-name="star"
            d="M10.002.478l3.085 6.22 6.911.988-5.007 4.854 1.174 6.84-6.177-3.224-6.184 3.234 1.186-6.842-5-4.838 6.912-1z"
            fill="#ffeb00"
          />
        </g>
        <g
          data-name="Mask Group 8"
          transform="rotate(-33 290.071 33.27)"
          clipPath="url(#prefix__f)">
          <path
            data-name="star"
            d="M17.118 6.489l3.106 6.249 6.909 1.014-4.981 4.85 1.2 6.863-6.192-3.256-6.167 3.22 1.167-6.856-5.014-4.871 6.9-.977z"
            fill="#ffeb00"
          />
        </g>
        <g
          data-name="Mask Group 6"
          transform="rotate(-17 306.917 51.636)"
          clipPath="url(#prefix__g)">
          <path
            data-name="star"
            d="M19.976 4.827l4.283 8.718 9.544 1.409-6.892 6.766 1.647 9.578-8.542-4.534-8.526 4.506 1.613-9.57-6.917-6.792 9.539-1.377z"
            fill="#ffeb00"
          />
        </g>
        <g
          data-name="Mask Group 7"
          transform="rotate(.974 -8894.186 7941.913)"
          clipPath="url(#prefix__h)">
          <path
            data-name="star"
            d="M13.875.614l4.287 7.889 9.586 1.265-6.94 6.14 1.636 8.672-8.571-4.093-8.575 4.096 1.638-8.669-6.939-6.143 9.586-1.267z"
            fill="#ffeb00"
          />
        </g>
      </g>
    </svg>
  );
};

export default Reward;
